<template>
<div>
  <el-card class="noticiaContainer">
      <router-link :to="{ name: 'Noticia', params: { id: noticia.Id }}">

        <div class="imagenContainer">
          <img v-if="noticia.PathImagen !== ''" class="imagen" :src="noticia.PathImagen">
          <img v-else class="imagenDefault" src="../../images/logo.png">
        </div>

            
        <div class="content">
          <div class="title">{{noticia.Titulo}}</div>
          <div class="body">{{noticia.Copete}}</div>
        </div>
        <div class="readMore">{{ $t('NOTICIAS_leer_mas') }}</div>
      </router-link>
  </el-card>
</div>
</template>

<script>


  export default {
    name: "NoticiaCard",
    props: {
    noticia: Object,
    },
    data() {
      return {
        defaultImage: './images/logo.png',
      }
    },

  }

</script>

<style scoped>

  .noticiaContainer {
    height: 340px;
  }

  .imagenContainer {
    background-color: #fdfafa;
    width: 100%;
    height: 200px;
  }

  .imagen {
    height: 200px;
  }

  .imagenDefault {
    width: 90%; 
    height: 100px; 
    padding: 50px 0px;
  }

  .content {
    padding: 17px;
    padding-bottom: 0;
    width: 90%;
  }

  .title {
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
    color: var(--main-color);
    text-align: left;
    padding-bottom: 7px;
    width: fit-content;
    border-bottom: 1px solid var(--main-color); 
  }

  .body {
    margin-top: 16px;
    text-align: left;
    font-size: 14px;
    line-height: 16px;
    color: #818181;
  }

</style>
